module.exports = "/_next/static/images/mississippi-0d01aae78717706c44fd79b2a26385c8.svg";